/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import Markdown from 'markdown-to-jsx';
import type { ReactNode } from 'react';

// Agent run notifications carry a preview of the agent's markdown answer; every
// other notification is plain prose (and may contain underscores/asterisks in
// ids that must NOT be treated as markdown), so markdown rendering is gated on
// the agent link.
export const isAgentNotificationContent = (link: string | undefined) =>
  Boolean(link?.startsWith('/agent'));

// Inline-only so the result drops into a line-clamped Typography without block
// margins; links render as plain text since the whole row is already clickable.
const INLINE_MARKDOWN_OPTIONS = {
  forceInline: true,
  overrides: { a: { component: 'span' } },
} as const;

export const renderNotificationContent = (content: string, link: string | undefined): ReactNode =>
  isAgentNotificationContent(link) ? (
    <Markdown options={INLINE_MARKDOWN_OPTIONS}>{content}</Markdown>
  ) : (
    content
  );
